(function() {
  function init() {
    document.querySelectorAll('.ovd__field').forEach(initField);
  }

  function initField(fieldEl) {
    if (fieldEl.__ovdInit) return;
    fieldEl.__ovdInit = true;

    const trigger = fieldEl.querySelector('[data-trigger]');
    const popover = fieldEl.querySelector('[data-popover]');
    const triggerText = fieldEl.querySelector('[data-trigger-text]');
    const currentValue = fieldEl.querySelector('[data-current-value]');
    const options = Array.from(fieldEl.querySelectorAll('.ovd__option'));
    const targetSelectId = fieldEl.dataset.targetSelectId;
    const targetSelect = targetSelectId ? document.getElementById(targetSelectId) : null;

    if (!trigger || !popover || !targetSelect) return;

    const state = { open: false };

    function openPopover() {
      closeOtherPopovers();
      popover.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      state.open = true;
      document.addEventListener('pointerdown', onDocPointerDown);
      const sel = options.find((o) => o.getAttribute('aria-selected') === 'true') || options[0];
      if (sel) sel.focus();
    }

    function closePopover() {
      if (!state.open) return;
      popover.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      state.open = false;
      document.removeEventListener('pointerdown', onDocPointerDown);
    }

    function onDocPointerDown(e) {
      if (fieldEl.contains(e.target)) return;
      closePopover();
    }

    function selectOption(optBtn) {
      const value = optBtn.dataset.value;
      options.forEach((o) => o.setAttribute('aria-selected', o === optBtn ? 'true' : 'false'));
      if (triggerText) triggerText.textContent = value;
      if (currentValue) currentValue.textContent = value;
      closePopover();
      trigger.focus();
      if (targetSelect.value !== value) {
        targetSelect.value = value;
        targetSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    trigger.addEventListener('click', (e) => {
      e.stopPropagation();
      if (state.open) closePopover(); else openPopover();
    });
    trigger.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowDown') {
        e.preventDefault();
        openPopover();
      }
    });
    options.forEach((optBtn) => {
      optBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        selectOption(optBtn);
      });
      optBtn.addEventListener('keydown', (e) => {
        const idx = options.indexOf(optBtn);
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          const next = options[Math.min(idx + 1, options.length - 1)];
          if (next) next.focus();
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          const prev = options[Math.max(idx - 1, 0)];
          if (prev) prev.focus();
        } else if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          selectOption(optBtn);
        } else if (e.key === 'Escape') {
          e.preventDefault();
          closePopover();
          trigger.focus();
        } else if (e.key === 'Tab') {
          closePopover();
        }
      });
    });
  }

  function closeOtherPopovers() {
    document.querySelectorAll('.ovd__field [data-popover]').forEach((p) => {
      if (!p.hidden) {
        p.hidden = true;
        const t = p.parentElement.querySelector('[data-trigger]');
        if (t) t.setAttribute('aria-expanded', 'false');
      }
    });
  }

  function readOptionValues() {
    const wrapper = document.querySelector('variant-selects-page, variant-selects');
    if (!wrapper) return [null, null, null];
    const selects = Array.from(wrapper.querySelectorAll('select[id^="Option-"]'));
    const sel = [null, null, null];
    selects.forEach((s) => {
      const m = s.id.match(/-(\d+)$/);
      if (!m) return;
      sel[parseInt(m[1], 10)] = (s.value || '').trim();
    });
    return sel;
  }

  function stockFlags() {
    const [kleur, breedte, diepte] = readOptionValues();
    return {
      kleur: !!(kleur && kleur.indexOf('(050)') !== -1),
      breedte: breedte === '50 cm' || breedte === '80 cm' || breedte === '100 cm',
      diepte: diepte === '30 cm' || diepte === '40 cm',
    };
  }

  function updateStockPills() {
    const f = stockFlags();
    // Kleur-pill (in kleur-dropdown): toon alleen als breedte EN diepte voorraad zijn.
    document.querySelectorAll('.kleur-dropdown-stock-pill').forEach((p) => {
      p.hidden = !(f.breedte && f.diepte);
    });
    // Breedte-pills (in mijn popover): toon alleen als kleur EN diepte voorraad zijn.
    document.querySelectorAll('.ovd__field[data-field-kind="breedte"] .ovd__stock-pill').forEach((p) => {
      p.hidden = !(f.kleur && f.diepte);
    });
    // Diepte-pills: toon alleen als kleur EN breedte voorraad zijn.
    document.querySelectorAll('.ovd__field[data-field-kind="diepte"] .ovd__stock-pill').forEach((p) => {
      p.hidden = !(f.kleur && f.breedte);
    });
  }

  function initStaffelWidget() {
    const widget = document.querySelector('[data-staffel-widget]');
    const offLabel = (widget && widget.dataset.offLabel) || 'korting';
    const saveLabel = (widget && widget.dataset.saveLabel) || 'bespaar';
    if (!widget || widget.__staffelInit) return;
    widget.__staffelInit = true;

    const chips = Array.from(widget.querySelectorAll('.staffel-widget__chip'));
    const overlay = widget.querySelector('[data-overlay]');
    const form = widget.querySelector('[data-staffel-form]');
    const formId = widget.querySelector('[data-staffel-form-id]');
    const formQty = widget.querySelector('[data-staffel-form-qty]');
    const productFormId = widget.dataset.productFormId;

    function isEligible() {
      const f = stockFlags();
      return f.kleur && f.breedte && f.diepte;
    }

    function readCurrentPriceCents() {
      const priceEl = document.querySelector('.price-regular .price') || document.querySelector('.price');
      if (!priceEl) return null;
      const txt = (priceEl.textContent || '').replace(/[^\d,.\-]/g, '').replace(',', '.');
      const num = parseFloat(txt);
      if (!isFinite(num)) return null;
      return Math.round(num * 100);
    }

    function readCurrentVariantId() {
      const f = productFormId ? document.getElementById(productFormId) : null;
      if (!f) return null;
      const idInput = f.querySelector('input[name="id"]');
      return idInput ? idInput.value : null;
    }

    function formatMoney(cents) {
      const euros = (cents / 100).toFixed(2).replace('.', ',');
      return '€' + euros;
    }

    function update() {
      const eligible = isEligible();
      overlay.hidden = eligible;
      const priceCents = eligible ? readCurrentPriceCents() : null;
      chips.forEach((chip) => {
        chip.disabled = !eligible;
        const qty = parseInt(chip.dataset.chipQty, 10);
        const pct = parseInt(chip.dataset.chipPct, 10);
        const sub = chip.querySelector('[data-chip-sub]');
        if (!sub) return;
        if (eligible && priceCents) {
          const savingsCents = Math.round(priceCents * qty * pct / 100);
          sub.innerHTML = pct + '% ' + offLabel + ' · ' + saveLabel + ' <span data-chip-savings>' + formatMoney(savingsCents) + '</span>';
        } else {
          sub.textContent = pct + '% ' + offLabel;
        }
      });
    }

    function addToCart(variantId, quantity) {
      const cartDrawer = document.querySelector('cart-drawer');
      const fd = new FormData();
      fd.append('id', variantId);
      fd.append('quantity', String(quantity));
      if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
        fd.append('sections', cartDrawer.getSectionsToRender().map((s) => s.id).join(','));
        fd.append('sections_url', window.location.pathname);
      }
      return fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: fd,
      })
        .then((r) => r.json())
        .then((response) => {
          if (response.status) {
            console.error('[staffel] cart add error:', response.description || response);
            return;
          }
          if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
            cartDrawer.renderContents(response);
          } else {
            window.location = (window.routes && window.routes.cart_url) || '/cart';
          }
        })
        .catch((e) => {
          console.error('[staffel] cart add failed:', e);
          window.location = (window.routes && window.routes.cart_url) || '/cart';
        });
    }

    chips.forEach((chip) => {
      chip.addEventListener('click', () => {
        if (chip.disabled || chip.dataset.loading === '1') return;
        const vid = readCurrentVariantId();
        if (!vid) return;
        chip.dataset.loading = '1';
        chip.classList.add('staffel-widget__chip--loading');
        addToCart(vid, parseInt(chip.dataset.chipQty, 10)).finally(() => {
          chip.dataset.loading = '';
          chip.classList.remove('staffel-widget__chip--loading');
        });
      });
    });

    const wrapper = document.querySelector('variant-selects-page, variant-selects');
    if (wrapper) {
      wrapper.querySelectorAll('select[id^="Option-"]').forEach((s) =>
        s.addEventListener('change', () => setTimeout(() => { update(); updateStockPills(); }, 50))
      );
    }

    const priceEl = document.querySelector('.price-regular .price') || document.querySelector('.price');
    if (priceEl) {
      const obs = new MutationObserver(() => update());
      obs.observe(priceEl, { childList: true, characterData: true, subtree: true });
    }

    update();
    updateStockPills();
  }

  function initKaderdeurLabelMirror() {
    document.querySelectorAll('.color-dropdown').forEach((wrap) => {
      const label = wrap.querySelector('.dropdown-label');
      const selectedText = wrap.querySelector('[id$="SelectedText"]');
      if (!label || !selectedText) return;
      if (label.querySelector('.ovd-mirror-value')) return;
      label.appendChild(document.createTextNode(': '));
      const span = document.createElement('span');
      span.className = 'ovd-mirror-value';
      span.textContent = (selectedText.textContent || '').trim();
      label.appendChild(span);
      new MutationObserver(() => {
        span.textContent = (selectedText.textContent || '').trim();
      }).observe(selectedText, { childList: true, characterData: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => { init(); initStaffelWidget(); initKaderdeurLabelMirror(); });
  } else {
    init();
    initStaffelWidget();
    initKaderdeurLabelMirror();
  }
})();
